import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function getServicosNfse(tpId, somenteAtivos = false) {
  try {
    const params = somenteAtivos ? { tp_id: tpId, ativos: true } : { tp_id: tpId }
    const { data } = await authHttp().get(routes.urlServicosNfse, { params })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveServicoNfse(servico) {
  try {
    const { data } = servico.id
      ? await authHttp().put(routes.urlPutServicoNfse(servico.id), servico)
      : await authHttp().post(routes.urlServicosNfse, servico)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCodigosTributacaoNacionalNfse(busca) {
  try {
    const { data } = await authHttp().get(routes.urlCodigosTributacaoNacionalNfse, {
      params: { busca },
    })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCodigosNbsNfse(busca) {
  try {
    const { data } = await authHttp().get(routes.urlCodigosNbsNfse, { params: { busca } })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
